import styled from '@emotion/styled'

import ContentWrapper from '@vio/atlas/helpers/ContentWrapper'

export const PageWrapper = styled(ContentWrapper)`
  display: flex;
  aligh-items: center;
  flex-direction: column;
`
